<app-preloader *ngIf="isLoading"></app-preloader>

<div id="financialProductEditMobile">
  <div class="title">
    <h3>Producto Financiero</h3>
  </div>
  <form [formGroup]="formFinance" class="formFinance">
    <div class="data">
      <div class="controlWrapper">
        <label for="">Producto financiero<span class="required">*</span></label>
        <div class="customSelect">
          <select type="text" formControlName="financialProduct" (change)="onChangeFinancialProduct()">
            <option *ngFor="let financialProduct of productList" [value]="financialProduct.value">
              {{ financialProduct.name }}
            </option>
          </select>
        </div>
      </div>
      <div *ngIf="_financialPackageOptions.length > 0; else withoutPackages" class="controlWrapper">
        <label for="">Paquete<span class="required">*</span></label>
        <div class="customSelect">
          <select type="text" formControlName="id" (change)="onChangePackage()">
            <option [value]="null" disabled selected>Seleccione un paquete</option>
            <option *ngFor="let package of _financialPackageOptions" [value]="package.id">
              {{ package.financialSetupName }}
            </option>
          </select>
        </div>
      </div>
      <ng-template #withoutPackages>
        <div class="noPkg">Sin paquetes financieros</div>
      </ng-template>
      <div *ngIf="_financialPackageOptions.length > 0" class="plan">
        <div class="controlWrapper">
          <label>Versión</label>
          <span class="value">{{ packageVersion }}</span>
        </div>
      </div>
      @if (_financialPackageOptions.length > 0 && formFinance.controls['id'].value && showSubsidyInfo()) {
        <div class="plan subsidyPreview">
          <div class="controlWrapper">
            <label>Subsidio</label>
            @if (isSubsidyNotApplicable()) {
              <span class="value">No aplica</span>
            } @else {
              @if (getSubsidyPreview(); as subsidy) {
                <div class="subsidyRow">
                  <span class="subsidyPercent">{{ subsidy.percentLeadingLabel }}</span>
                  <span class="subsidyAmountLine">
                    <span class="subsidyAmount">{{ subsidy.amount | currency : '' : '' }}</span>
                    @if (models?.currency) {
                      <span class="subsidyCurrency">{{ models?.currency }}</span>
                    }
                  </span>
                </div>
              } @else {
                <span class="value">No aplica</span>
              }
            }
          </div>
        </div>
      }
    </div>

    <div *ngIf="_financialPackageOptions.length > 0 && paymentTerms.length > 0; else withoutPaymentTerms" class="data">
      <div *ngIf="_financialPackageOptions.length > 0" class="plan">
        <div class="controlWrapper">
          <label>Plan (descripción del paquete)</label>
          <span class="value">{{ packageDescription }}</span>
        </div>
      </div>

      <div class="controlWrapper">
        @if (formFinance.controls['id'].value){
        <label for="">Plazo<span class="required">*</span></label>
        <div class="customSelect">
          <select type="text" formControlName="termId" (change)="onChangeTerm()">
            <option [value]="null" disabled selected>Seleccione un plazo</option>
            <option *ngFor="let terms of paymentTerms" [value]="terms.id">{{ terms.term }} MESES</option>
          </select>
        </div>
        }
      </div>

      <div class="wrapperG2">
        @if(formFinance.controls['financialProduct'].value != 'PURE_LEASING'){
        <div class="controlWrapper">
          <div class="wrapperSX">
            @if (formFinance.controls['termId'].value){
            <label for="">Tasa</label>
            <input
              type="text"
              class="size1 gapRight"
              formControlName="nominalRate"
              [value]="formFinance.controls['nominalRate'].value"
              [disabled]="true"
              (change)="onChangeTerm()"
            />
            <span class="type">%</span>
            }
          </div>
        </div>
        }
      </div>
      <!-- Tipo de pago -->
      <div class="controlWrapper tipoDePago">
        <label for="">Tipo de pago</label>
        <span class="value">
          {{ quoteService.getPaymentType(formFinance.controls['paymentType'].value) }}
        </span>
      </div>
    </div>

    <ng-template #withoutPaymentTerms>
      <div *ngIf="_financialPackageOptions.length > 0 && paymentTerms.length == 0" class="note">
        Sin plazos disponibles. Por favor, seleccione otro paquete financiero.
      </div>
    </ng-template>

    <div *ngIf="_financialPackageOptions.length > 0 && paymentTerms.length > 0" class="data">
      @if (showDownPayment() && formFinance.controls['termId'].value ) {
      <!-- Enganche -->
      <div class="wrapper">
        <div class="controlWrapper">
          <label
            >Enganche ({{ downPaymentTaxType === taxType.invoiceWithTax ? 'incluye IVA' : 'no incluye IVA' }})
            <span class="required">*</span>
          </label>

          <div class="wrapperEnganche">
            <!-- Es porcentaje -->
            <div class="porcentaje" *ngIf="formFinance.controls['downPaymentTaxType'].value != taxType.fixedAmount">
              <input
                *ngIf="formFinance.controls['termId'].value"
                class="size1"
                type="number"
                formControlName="downPaymentTax"
                (blur)="calculateDownPayment('downPayment', 'percentaje')"
                (keypress)="preventInvalidCharacters($event)"
                (change)="deletePaymentsDeal()"
              />

              <span class="value" *ngIf="formFinance.controls['downPaymentTaxType'].value != taxType.fixedAmount"
                >%</span
              >
              <div class="rango">Min {{ minDownPaymentPercentage }}%<br />Max {{ maxDownPaymentPercentage }}%</div>
            </div>

            <ng-container *ngIf="formFinance.controls['downPaymentTaxType'].value != taxType.fixedAmount">
              <input
                type="number"
                id="downPayment"
                style="display: none"
                formControlName="downPayment"
                (blur)="calculateDownPayment('downPayment', 'fixed')"
                (keypress)="preventInvalidCharacters($event)"
                (change)="deletePaymentsDeal()"
              />
              <span type="text" id="hidden-downPayment" class="value">
                {{ formFinance.controls['downPayment'].value | currency : '' : '' }}</span
              >
            </ng-container>
            <div class="value">{{ models?.currency }}</div>

            <!-- Es monto fijo -->
            <ng-container *ngIf="formFinance.controls['downPaymentTaxType'].value == taxType.fixedAmount">
              <div class="controlWrapper monto">
                <input
                  type="number"
                  id="downPayment"
                  class="amount"
                  style="display: none"
                  formControlName="downPayment"
                  (blur)="calculateDownPayment('downPayment', 'fixed')"
                  (keypress)="preventInvalidCharacters($event)"
                />
                <input
                  type="text"
                  id="hidden-downPayment"
                  class="amount"
                  (focus)="showAmountInput('downPayment')"
                  style="display: flex"
                  [value]="formFinance.controls['downPayment'].value | currency : '' : ''"
                />
              </div>
            </ng-container>
          </div>
        </div>
      </div>
      }

      <!-- Comisión por apertura -->
      <div class="controlWrapper">
        @if (formFinance.controls['termId'].value){
        <label>Comisión por apertura <span class="required">*</span></label>
        <div class="wrapperComision">
          <!-- Es porcentaje -->
          <div class="porcentaje" *ngIf="formFinance.controls['openingFeeType'].value != taxType.fixedAmount">
            <span class="value">
              {{ formFinance.controls['openingFeeTax'].value }}
            </span>
            <span class="value" *ngIf="formFinance.controls['openingFeeType'].value != taxType.fixedAmount">%</span>
            <span class="value">(Monto a financiar más IVA)</span>
          </div>
        </div>
        }
      </div>

      @if (formFinance.controls['financialProduct'].value == 'PURE_LEASING') {
      <!-- Garantía Daimler -->
      <!-- Garantía Terceros -->
        @if (showResidualValueThirdParty && residualValueSelected) {
          <div class="controlWrapper porcentaje">
            <label for="thirdPartyWarrantyRate">Garantía Terceros</label>
            <div class="wrapperRow">
              <div>
                <input
                  id="thirdPartyWarrantyRate"
                  formControlName="externalWarrantyRate"
                  class="size1 gapRight"
                  type="number"
                />
              </div>
              <span class="type gapRight">%</span>
              <div class="rango">
                <span class="note">
                  Min {{ residualValueSelected.externalsMinRate }}%<br />
                  Max {{ residualValueSelected.externalsMaxRate }}%
                </span>
              </div>
            </div>
          </div>
        }
      } @else if(hasExemptTax){
        <div>
          <div class="controlWrapper">
            <label for="taxFree">{{ 'VAT exempt' | translate }}</label>
            <div class="customSelect">
              <select id="taxFree" formControlName="taxFree">
                @for(option of taxFreeOptions; track option.value){
                  <option [value]="option.value">
                    {{ option.display }}
                  </option>
                  }
              </select>
            </div>
          </div>
        </div>
      }
    </div>
  </form>
</div>
<ng-template #modalTemplate>
  <div class="modal" style="max-width: 620px">
    <a class="close" (click)="cancelChanges()">Cerrar</a>
    <h1>Eliminar propuestas</h1>
    <p>Está editando datos sensibles, si continúa con los cambios la propuesta de seguro será eliminada.</p>
    <div class="modalActions index">
      <button (click)="cancelChanges()" class="secondary">Cancelar</button>
      <button (click)="resetAndDeleteInsurance()" class="primary">Eliminar</button>
    </div>
  </div>
</ng-template>
